import { AxiosResponse } from 'axios';
import { defaultTo, map, pipe, sort } from 'ramda';

export const categoriesToOptionsConverter = <T extends object>({
  getLabel = (value: any) => value.name,
  getValue = (value: any) => value.code,
  sortBy = 'value'
}: {
  getLabel?: (value: T) => any;
  getValue?: (value: T) => any;
  sortBy?: 'value' | 'label' | 'sortOrder';
}) =>
  pipe<
    [AxiosResponse<T[]>],
    T[] | undefined,
    T[],
    {
      value: string | number;
      label: string;
    }[],
    {
      value: string | number;
      label: string;
    }[]
  >(
    (dto) => dto.data,
    defaultTo([]),
    map((value) => ({
      label: getLabel(value),
      value: getValue(value),
      sortOrder:
        'sortOrder' in value
          ? (value as { sortOrder?: string | number }).sortOrder
          : undefined
    })),
    sort((optionA, optionB) => {
      const optA = optionA[sortBy];
      const optB = optionB[sortBy];

      if (typeof optA === 'string' && typeof optB === 'string') {
        return optA.localeCompare(optB);
      } else if (typeof optA === 'number' && typeof optB === 'number') {
        return optA - optB;
      }
      return 0;
    })
  );
